// extracted by mini-css-extract-plugin
export var infoItem = "_tt-2";
export var title = "_tt-0";
export var value = "_tt-1";